export default __webpack_public_path__ + "static/media/facilityManagement.4dcca3a7.jpg";